module.exports = __webpack_public_path__ + "static/media/bugReport.a60e2642.svg";